module.exports = __webpack_public_path__ + "img/tall-tree-no-fruit.244e483d.png";